// extracted by mini-css-extract-plugin
module.exports = {"cardIcon":"CardIcon_cardIcon__3knri"};